<template>
  <div class="nps">
    <h2 class="nps__header" v-html="header"></h2>

    <div v-show="!showThanks">
      <div class="nps__container">
        <span class="nps__top-label">{{ratingTopLabel}}</span>
        <hr class="nps__separator">

        <div class="nps__list">
          <div
            v-for="rating in this.ratings"
            :key="rating.value"
            @click.prevent="submitNPSRating(rating.value)"
            :class="{
              'nps__item': true,
              ['nps__item--' + rating.value]: true,
              'nps__item--active': selectedRatingId === rating.value}">
            {{rating.value}}
          </div>
        </div>

        <hr class="nps__separator nps__separator--bottom">
        <span class="nps__bottom-label">{{ratingBottomLabel}}</span>
      </div>

      <div class="tla-form-group">
        <label class="tla-form-group__label">{{scoreReasonLabel}}</label>
        <textarea v-model="npsText" class="tla-form-group__textarea" :placeholder="scoreReasonPlaceholder"></textarea>
        <div class="nps__microcopy" v-html="tellUsMicrocopy"></div>
      </div>

      <button
        class="btn tla-btn tla-btn--info"
        @click="submitNPSText"
        type="button"
        name="nps-submit-button"
        id="nps-submit-button">
        {{submitText}}
      </button>
    </div>

    <div v-show="showThanks" class="nps__box">
      <p class="nps__thanks">Thanks for your feedback</p>
      <div class="thanks__tick"></div>
      <p class="nps__thanks-bottom-text" v-html="thanksText"></p>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Vue, Component, Prop, Inject, Watch
} from 'vue-property-decorator';
import {
  Action, namespace
} from 'vuex-class';
import RatingPoint from '@/models/RatingPoint';
import VeeValidate, { FieldError, Validator } from 'vee-validate';
import ExtraData from '../../models/ExtraData';

const PostEnquiryModule = namespace('postEnquiryModule');

@Component
export default class NPSComponent extends Vue {
  @PostEnquiryModule.Action public submitEnquiryExtraData;

  @Prop({ default: '' })
  public header!: string;

  @Prop({ default: 'Not at all likely' })
  public ratingTopLabel!: string;

  @Prop({ default: 'Extremely likely' })
  public ratingBottomLabel!: string;

  @Prop({ default: 'What is the primary reason for your score?' })
  public scoreReasonLabel!: string;

  @Prop({ default: 'We’d love to hear your thoughts…' })
  public scoreReasonPlaceholder!: string;

  @Prop({ default: '' })
  public tellUsMicrocopy!: string;

  @Prop({ default: 'Send Feedback' })
  public submitText!: string;

  public showThanks: boolean = false;

  public thanksText: string = 'Our goal is to create <span>the best possible service</span>, and your thoughts, ideas, and suggestions play a major role in helping us identify opportunities to improve.';

  public npsText: string = '';

  private selectedRatingId: number = -1;

  public ratings: RatingPoint[] = [
    new RatingPoint(0),
    new RatingPoint(1),
    new RatingPoint(2),
    new RatingPoint(3),
    new RatingPoint(4),
    new RatingPoint(5),
    new RatingPoint(6),
    new RatingPoint(7),
    new RatingPoint(8),
    new RatingPoint(9),
    new RatingPoint(10)
  ];

  public submitNPSRating(value: number) {
    this.selectedRatingId = value;

    const data: ExtraData[] = [
      {
        keyName: 'tlaNPSRating',
        keyValue: value.toString()
      }
    ];

    this.submitEnquiryExtraData(data);
  }

  public submitNPSText() {
    if (this.npsText && this.npsText.length > 0) {
      const data: ExtraData[] = [
        {
          keyName: 'tlaNPSText',
          keyValue: this.npsText
        }
      ];

      this.submitEnquiryExtraData(data);
      this.showThanks = true;
    }
  }

  public queryStringCheck() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const value = urlParams.get('tlaNPSRating');
      if (value === null) {
        return;
      }

      const parsed = parseInt(value, 10);
      if (Number.isNaN(parsed) || this.ratings.length < parsed) {
        return;
      }

      const ratingPointItem = this.ratings.find((x) => x.value === parsed);
      if (ratingPointItem) {
        this.submitNPSRating(ratingPointItem.value);
      }
    } catch (error) {
      console.log('URLSearchParams not supoorted');
    }
  }

  public created() {
    this.queryStringCheck();
  }
}
</script>
